import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import {
  useListCategoriesQuery,
  useUpdateCategoryMutation,
  type CategoryType,
} from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'UpsertCategory',
  props: {
    category: null
  },
  emits: ["saved"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'saved'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  category?: CategoryType | null
};





const dialogOpen = ref(false)
const editedItem = ref<{
  id?: number
  labelI18n: { en?: string; de?: string }
  parentId: number | null
}>({
  labelI18n: {},
  parentId: null,
})

const { mutate: upsertCategory, loading } = useUpdateCategoryMutation()
const { result: categoriesResult } = useListCategoriesQuery()

const isEditMode = computed(() => Boolean(props.category?.id))
const parentCategoryOptions = computed(() =>
  (categoriesResult.value?.listCategories ?? []).filter(
    (category) => category.id !== props.category?.id,
  ),
)

const hasAnyLabel = computed(
  () =>
    Boolean(editedItem.value?.labelI18n?.en?.trim()) ||
    Boolean(editedItem.value?.labelI18n?.de?.trim()),
)

const resetEditedItem = () => {
  editedItem.value = {
    id: props.category?.id,
    labelI18n: {
      en: props.category?.labelI18n?.en ?? '',
      de: props.category?.labelI18n?.de ?? '',
    },
    parentId: props.category?.parentId ?? null,
  }
}

const openDialog = () => {
  resetEditedItem()
  dialogOpen.value = true
}

watch(
  () => props.category,
  () => {
    if (!dialogOpen.value) {
      resetEditedItem()
    }
  },
  { deep: true },
)

const submitCategory = async () => {
  await upsertCategory({
    input: {
      id: editedItem.value.id,
      labelI18n: {
        en: editedItem.value.labelI18n.en?.trim() || undefined,
        de: editedItem.value.labelI18n.de?.trim() || undefined,
      },
      parentId: editedItem.value.parentId ? String(editedItem.value.parentId) : null,
    },
  })
  dialogOpen.value = false
  emit('saved')
}

return { __sfc: true,props, emit, dialogOpen, editedItem, upsertCategory, loading, categoriesResult, isEditMode, parentCategoryOptions, hasAnyLabel, resetEditedItem, openDialog, submitCategory }
}

})